// Media library storage (OPFS-SQLite). One row per uploaded asset, so
// the creator's library survives reloads and items can be re-inserted
// into any draft. The bytes live in the public repo (inline commit or
// Release asset); this table just records the reference.

import { exec, query } from "./sqlite";
import type { MediaRef } from "../github-media";

export interface MediaItem extends MediaRef {
  id: string;
  google_sub: string;
  created_at: number;
}

let initialized = false;

async function ensureTable(): Promise<void> {
  if (initialized) return;
  await exec(`
    CREATE TABLE IF NOT EXISTS media (
      id          TEXT PRIMARY KEY,
      google_sub  TEXT NOT NULL,
      kind        TEXT NOT NULL,
      url         TEXT NOT NULL,
      mime        TEXT NOT NULL,
      size        INTEGER NOT NULL,
      filename    TEXT NOT NULL,
      storage     TEXT NOT NULL,
      created_at  INTEGER NOT NULL
    )
  `);
  initialized = true;
}

let counter = 0;
function makeId(): string {
  counter = (counter + 1) % 100000;
  return `media_${Date.now().toString(36)}_${counter.toString(36)}`;
}

export async function listMedia(googleSub: string): Promise<MediaItem[]> {
  await ensureTable();
  return query<MediaItem>(`SELECT * FROM media WHERE google_sub = ? ORDER BY created_at DESC`, [googleSub]);
}

export async function addMedia(googleSub: string, ref: MediaRef): Promise<MediaItem> {
  await ensureTable();
  const item: MediaItem = { ...ref, id: makeId(), google_sub: googleSub, created_at: Date.now() };
  await exec(
    `INSERT INTO media (id, google_sub, kind, url, mime, size, filename, storage, created_at)
     VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)`,
    [item.id, googleSub, item.kind, item.url, item.mime, item.size, item.filename, item.storage, item.created_at],
  );
  return item;
}

export async function deleteMedia(id: string): Promise<void> {
  await ensureTable();
  await exec(`DELETE FROM media WHERE id = ?`, [id]);
}
